import { Platform } from 'react-native';
import { ButtonTypeTokens, IconTokens, } from '@voltmoney/schema';
import { MARITAL_STATUS, } from './types';
import { api } from '../../../configs/api';
import { getAppHeader } from '../../../configs/config';
import { ROUTE } from '../../../routes';
import SharedPropsService from '../../../SharedPropsService';
import { getParameters, isFromAndroidWebview, nextStepCredStepper } from '../../../configs/utils';
import AsyncStorage from "@react-native-async-storage/async-storage";
import { LENDER_ID } from "../../../configs/constants";
let martialStatus = null;
let fatherFirstName = '';
let fatherLastName = '';
let motherFirstName = '';
let motherLastName = '';
let qualification = null;
export const onChangeInput = async (action, _datastore, { setDatastore }) => {
    switch (action.payload.widgetID) {
        case 'fatherFirstNameInput': {
            fatherFirstName = action.payload.value.trim();
            break;
        }
        case 'fatherLastNameInput': {
            fatherLastName = action.payload.value.trim();
            break;
        }
        case 'motherFirstNameInput': {
            motherFirstName = action.payload.value.trim();
            break;
        }
        case 'motherLastNameInput': {
            motherLastName = action.payload.value.trim();
            break;
        }
    }
    if (martialStatus &&
        fatherFirstName &&
        fatherLastName &&
        motherFirstName &&
        motherLastName &&
        qualification) {
        await setDatastore(ROUTE.KYC_ADDITIONAL_DETAILS, 'continue', {
            type: ButtonTypeTokens.LargeFilled,
        });
    }
    else {
        await setDatastore(ROUTE.KYC_ADDITIONAL_DETAILS, 'continue', {
            type: ButtonTypeTokens.LargeOutline,
        });
    }
};
export const onSelect = async (action, _datastore, { setDatastore }) => {
    qualification = action.payload.value;
    if (martialStatus &&
        fatherFirstName &&
        fatherLastName &&
        motherFirstName &&
        motherLastName &&
        qualification) {
        await setDatastore(ROUTE.KYC_ADDITIONAL_DETAILS, 'continue', {
            type: ButtonTypeTokens.LargeFilled,
        });
    }
};
export const toggleCTA = async (action, _datastore, { setDatastore }) => {
    if (action.payload.value == MARITAL_STATUS.SINGLE) {
        await setDatastore(action.routeId, 'singleRadio', {
            name: IconTokens.RadioCircleFilled,
        });
        await setDatastore(action.routeId, 'marriedRadio', {
            name: IconTokens.RadioCircleNotFilled,
        });
        martialStatus = MARITAL_STATUS.SINGLE;
    }
    else if (action.payload.value == MARITAL_STATUS.MARRIED) {
        await setDatastore(action.routeId, 'singleRadio', {
            name: IconTokens.RadioCircleNotFilled,
        });
        await setDatastore(action.routeId, 'marriedRadio', {
            name: IconTokens.RadioCircleFilled,
        });
        martialStatus = MARITAL_STATUS.MARRIED;
    }
    if (martialStatus &&
        fatherFirstName &&
        fatherLastName &&
        motherFirstName &&
        motherLastName &&
        qualification) {
        await setDatastore(ROUTE.KYC_ADDITIONAL_DETAILS, 'continue', {
            type: ButtonTypeTokens.LargeFilled,
        });
    }
};
export const triggerCTA = async (action, _datastore, { navigate, setDatastore, network, instrumentTrack }) => {
    instrumentTrack('KYC_ADDITIONAL_INFO_CONFIRM_BUTTON_CLICKED', {
        marital_status: martialStatus,
        qualification: qualification,
    });
    // @ts-ignore
    const selectedItem = action.payload.selectedItem;
    console.warn("PAYLOAD @#@!#!@#@!", action.payload);
    await setDatastore(action.routeId, 'kycPage', {
        loading: true,
    });
    const user = await SharedPropsService.getUser();
    let applicationId;
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = user.linkedApplications[0].applicationId;
    }
    const lenderId = user.linkedApplications[0].lenderAccountId;
    const response = await network.post(`${api.additionalDetails}${applicationId}`, {
        maritalStatus: selectedItem.maritalStatus,
        qualification: selectedItem.qualification,
        fatherFirstName: selectedItem.fatherFirstName,
        fatherLastName: selectedItem.fatherLastName,
        ...lenderId.toLowerCase() !== LENDER_ID.TATA.toLowerCase() && { motherFirstName: selectedItem.motherFirstName },
        ...lenderId.toLowerCase() !== LENDER_ID.TATA.toLowerCase() && { motherLastName: selectedItem.motherLastName },
        ...selectedItem?.incomeRangeValue && { incomeRange: selectedItem?.incomeRangeValue },
        ...selectedItem?.purposeOfLoan && { purposeOfLoan: selectedItem?.purposeOfLoan },
        ...selectedItem?.useOfLoanValue && { useOfLoanValue: selectedItem?.useOfLoanValue },
        ...selectedItem?.employmentStatus && { employmentStatus: selectedItem?.employmentStatus },
        ...selectedItem?.sourceOfIncome && { sourceOfIncome: selectedItem?.sourceOfIncome },
    }, {
        headers: await getAppHeader(),
    });
    const currentStepId = response?.data?.updatedApplicationObj?.currentStepId;
    const stepStatusMap = response?.data?.updatedApplicationObj?.stepStatusMap;
    const routeObj = await nextStepCredStepper(currentStepId);
    if (currentStepId) {
        user.linkedApplications[0].stepStatusMap = stepStatusMap;
        await SharedPropsService.setUser(user);
        await navigate(routeObj?.routeId, routeObj?.params);
        // await setDatastore(action.routeId, 'kycPage', <ButtonProps>{
        //     loading: false,
        // })
    }
};
export const setQualification = async (qualificationVal) => {
    qualification = qualificationVal;
};
export const GoBackAction = async (action, _datastore, { goBack, navigate, navigateToBase, setDatastore }) => {
    await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
        successCard: false
    });
    await navigateToBase(ROUTE.KYC_STEPPER);
};
export const needHelpAction = async (action, datastore, { navigate }) => {
    let isFromTdl = false;
    if (Platform.OS === 'web') {
        let params = getParameters(window.location.href);
        if (params.platform === "TATADIGITAL" /* AppPlatform.TDL */) {
            isFromTdl = true;
        }
        if (isFromAndroidWebview() && isFromTdl) {
            window.open("FAQ_CLICKED", "_parent");
            //@ts-ignore
        }
        else {
            await navigate(ROUTE.CONTACT_US_CARD);
        }
        // @ts-ignore
        window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("FAQ");
    }
    else {
        await navigate(ROUTE.CONTACT_US_CARD);
    }
};
